import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import {
  fetchPlanDetailsAsync,
  fetchPlanDetailFilterAsync,
  fetchMorePlanItemsAsync,
  updatePendingFilters,
} from 'store/planDetails/actions';

import { PlanDetails, PlanDetailsErrors } from 'PlanDetails-Types';

export const isFetching = createReducer(false as boolean)
  .handleAction([fetchPlanDetailsAsync.request], () => true)
  .handleAction([fetchPlanDetailsAsync.success, fetchPlanDetailsAsync.failure], () => false);

export const isFetchingMoreItems = createReducer(false as boolean)
  .handleAction([fetchMorePlanItemsAsync.request], () => true)
  .handleAction([fetchMorePlanItemsAsync.success, fetchMorePlanItemsAsync.failure], () => false);

export const planDetails = createReducer({} as PlanDetails)
  .handleAction(fetchPlanDetailsAsync.success, (_state, action) => action.payload)
  .handleAction(fetchPlanDetailsAsync.failure, () => ({} as PlanDetails))
  .handleAction(fetchMorePlanItemsAsync.success, (state, action) => ({
    ...state,
    offset: action.payload.offset,
    limit: action.payload.limit,
    items: state.items.concat(action.payload.items),
  }));

export const errors = createReducer([] as PlanDetailsErrors[]).handleAction(
  fetchPlanDetailsAsync.failure,
  (_state, action) => action.payload,
);

// only being used as pending filters while filter selection
export const isFetchingFilters = createReducer(false)
  .handleAction(fetchPlanDetailFilterAsync.request, () => true)
  .handleAction(
    [fetchPlanDetailFilterAsync.success, fetchPlanDetailFilterAsync.failure],
    () => false,
  );

export const prefetchedPlanDetails = createReducer({} as PlanDetails)
  .handleAction(
    [updatePendingFilters, fetchPlanDetailFilterAsync.success, fetchPlanDetailsAsync.success],
    (_state, action) => action.payload,
  )
  .handleAction(fetchPlanDetailsAsync.failure, () => ({} as PlanDetails));

const planDetailsReducer = combineReducers({
  isFetching,
  isFetchingMoreItems,
  isFetchingFilters,
  planDetails,
  prefetchedPlanDetails,
  errors,
});

export default planDetailsReducer;
export type PlanDetailsState = ReturnType<typeof planDetailsReducer>;
